import AuthLayout from "@/shared/layouts/auth-layout/auth-layout";
import RightArea from "@/features/auth/templates/right-area/right-area";
import WorkspaceInviteView from "./workspace-invite-view";

export default function WorkspaceInvitePage() {
  return (
    <AuthLayout rightComponent={<RightArea />}>
      <WorkspaceInviteView />
    </AuthLayout>
  );
}

